module.exports = __webpack_public_path__ + "static/img/goSmallBk.bf865d42.png";